import { CryptoService } from '@app/core/services/crypto/crypto.service';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { map } from 'rxjs/operators';
import { EncryptIntercepList } from './encrypt_intercept_list';
import { JwtService } from '@app/core/services/jwt/jwt-services/jwt-service';

@Injectable({
  providedIn: 'root',
})
export class HttpEncryptedInterceptor {
  constructor(private cryptoService: CryptoService, private jwt: JwtService) {
    // if (environment.showLogs === true){
    //   (window as any).turing = this.cryptoService;
    // }
  }

  intercept<T>(
    request: HttpRequest<T>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {

    if (environment.useEncrypt == false) return next.handle(request);
    try {
      if (`${environment.basePath}/${this.jwt.endpoint}` == request.url) return next.handle(request);
    } catch (error) { }

    const encryptedRequest = this.encrypt(request);

    return next.handle(encryptedRequest).pipe(
      map((event: HttpEvent<any>) => {
        if (!(event instanceof HttpResponse)) return event;

        return this.decrypt(event);
      }),
    );
  }

  showLog(data: any, url: string, logType: string) {
    if (environment.showLogs == false) return;

    try {
      console.warn(`${logType}

      URL: ${url}

      ${JSON.stringify(data)}...
      `);
    } catch (error) {
      console.warn(`${logType} URL: ${url}`);
    }
  }

  private decrypt(httpEvent: HttpEvent<any>): HttpEvent<any> {
    if (
      !(httpEvent as any).body ||
      !(httpEvent as any).body.encryptedObject ||
      Object.keys((httpEvent as any).body).length == 0
    )
      return httpEvent;

    if (httpEvent instanceof HttpResponse) {
      this.showLog(
        this.cryptoService.decrypt(httpEvent.body.encryptedObject).toString(),
        httpEvent.url,
        ' <== DECRYPT',
      );

      try {
        const data = this.cryptoService
          .decrypt(httpEvent.body.encryptedObject)
          .toString();

        const newEvent = httpEvent.clone({ body: JSON.parse(data) });
        return newEvent as HttpEvent<any>;
      } catch (error) {
        const newEvent = httpEvent.clone({ body: httpEvent.body });
        return newEvent as HttpEvent<any>;
      }
    } else return httpEvent;
  }

  encrypt(httpRequest: HttpRequest<any>) {
    if (!httpRequest.body) return httpRequest;

    this.showLog(httpRequest.body, httpRequest.url, ' ==> ENCRYPT');

    let encryptedData;

    if (
      this.getType(httpRequest.body) == 'object' ||
      this.getType(httpRequest.body) == 'array'
    ) {
      encryptedData = this.cryptoService.encrypt(
        JSON.stringify(httpRequest.body),
      );
    } else {
      encryptedData = this.cryptoService.encrypt(httpRequest.body);
    }

    const payload = JSON.stringify({ encryptedObject: encryptedData });

    try {
      return httpRequest.clone({ body: JSON.parse(payload) });
    } catch (error) {
      return httpRequest.clone({ body: payload });
    }
  }

  shouldBeIntercepted(httpPayload): boolean {
    return true;
  }

  getType(p) {
    if (Array.isArray(p)) return 'array';
    else if (typeof p == 'string') return 'string';
    else if (p != null && typeof p == 'object') return 'object';
    else return 'other';
  }
}
